import { CustomerAuthCodeValidation } from "types";
import { z } from "zod";
import { apiClient } from "../client";

export const validateAuthCode = async (customerAuthCode: CustomerAuthCodeValidation) =>
  z
    .object({ api_key: z.string(), customer_id: z.string() })
    .parse((await apiClient.get("v1/validate_auth_code", { params: customerAuthCode })).data);
